import { formatNumber } from '@debbie/common/dist/index.js';
import { getPropertyFilterType } from '@debbie/common/dist/insights/property-filter.js';
import moment from 'moment';
const filterBadges = {
    creditorIds: (cF, lang) => cF.creditorIds
        ? `${cF.creditorIds.length} ${lang.caseFilter.selectedCreditors}`
        : '',
    visitedByUserIds: (cF, lang) => lang.caseFilter.caseVisitedBy,
    visitedAt: {
        from: (cF, lang) => (dateFormat) => `${lang.caseFilter.caseVisitedAfter} ${cF.visitedAt && moment(cF.visitedAt.from).format(dateFormat)}`,
        to: (cF, lang) => (dateFormat) => `${lang.caseFilter.caseVisitedBefore} ${cF.visitedAt && moment(cF.visitedAt.to).format(dateFormat)}`,
    },
    caseStatuses: (cF, lang) => `${lang.caseFilter.caseStatus}: ${cF.caseStatuses
        ?.map((status) => lang.cases[status])
        .join(', ')}`,
    caseEndReasonIds: (cF, lang) => lang.caseFilter.endReasons,
    caseGroups: (cF, lang) => lang.caseFilter.caseGroup,
    caseCreationDate: {
        from: (cF, lang) => (dateFormat) => `${lang.caseFilter.caseCreatedAfter} ${cF.caseCreationDate &&
            moment(cF.caseCreationDate.from).format(dateFormat)}`,
        to: (cF, lang) => (dateFormat) => `${lang.caseFilter.caseCreatedBefore} ${cF.caseCreationDate && moment(cF.caseCreationDate.to).format(dateFormat)}`,
    },
    caseEndedDate: {
        from: (cF, lang) => (dateFormat) => `${lang.caseFilter.caseEndedAfter} ${cF.caseEndedDate && moment(cF.caseEndedDate.from).format(dateFormat)}`,
        to: (cF, lang) => (dateFormat) => `${lang.caseFilter.caseEndedBefore} ${cF.caseEndedDate && moment(cF.caseEndedDate.to).format(dateFormat)}`,
    },
    caseSeqIds: (cF, lang) => lang.caseFilter.caseSeqIdFilterBadge,
    exceptCaseSeqIds: (cF, lang) => lang.caseFilter.exceptCaseSeqIds,
    maxRkiRegistrations: (cF, lang) => `${lang.caseFilter.maxRkiRegistrationsBadge} ${cF.maxRkiRegistrations}`,
    minRkiRegistrations: (cF, lang) => `${lang.caseFilter.minRkiRegistrationsBadge} ${cF.minRkiRegistrations}`,
    isReportedByCollector: (cF, lang) => `RKI: ${cF.isReportedByCollector
        ? lang.caseFilter.isRegisteredByCollector
        : lang.caseFilter.isNotRegisteredByCollector}`,
    hasEmail: (cF, lang) => lang.caseFilter.contactHasEmailBadge,
    hasAddress: (cF, lang) => lang.caseFilter.contactHasAddressBadge,
    hasPhone: (cF, lang) => lang.caseFilter.contactHasPhoneBadge,
    hasAlternativeContact: (cF, lang) => typeof cF.hasAlternativeContact === 'boolean' && cF.hasAlternativeContact
        ? lang.caseFilter.alternativeContactBadge
        : lang.caseFilter.debtorBadge,
    isCompany: (cF, lang) => typeof cF.isCompany === 'boolean' && cF.isCompany
        ? lang.caseFilter.company
        : lang.caseFilter.person,
    activePaymentMethod: (cF, lang) => typeof cF.activePaymentMethod === 'boolean' && cF.activePaymentMethod
        ? lang.caseFilter.hasCard
        : lang.caseFilter.doNotHaveCard,
    companyStatuses: (cF, lang) => lang.caseFilter.companyStatus,
    courtIds: (cF, lang) => lang.caseFilter.courtBadge,
    gender: () => '',
    companyBranches: (cF, lang) => lang.caseFilter.companyBranch,
    companyTypes: (cF, lang) => !!(cF.companyTypes && cF.companyTypes.length)
        ? cF.companyTypes.join(', ')
        : '',
    withSatisfactions: (cF, lang) => lang.caseFilter.satisfactions,
    economyOnlyVoucherTypeIds: (cF, lang) => lang.caseFilter.economyOnlyVoucherTypeIds,
    economyMinBalance: (cF, lang) => `${lang.caseFilter.economyMin} ${formatNumber(cF.economyMinBalance || 0)}`,
    economyMaxBalance: (cF, lang) => `${lang.caseFilter.economyMax} ${formatNumber(cF.economyMaxBalance || 0)}`,
    billingModelIds: (cF, lang) => lang.caseFilter.economySelectedBillingModels,
    billingAppendixSetupIds: (cF, lang) => lang.caseFilter.economySelectedBillingAppendixSetups,
    inWorkflowIds: (cF, lang) => lang.caseFilter.inSelectedWorkflows,
    nextTaskIds: (cF, lang) => lang.caseFilter.nextTaskIds,
    currentTaskIds: (cF, lang) => lang.caseFilter.currentTaskIds,
    noNextTask: (cF, lang) => lang.caseFilter.noNextTask,
    documentTypes: (cF, lang) => lang.caseFilter.hasDocumentOfTypeBadge,
    documentTypesIsSigned: (cF, lang) => lang.caseFilter.documentsIsSigned,
    hasFoundation: (cF, lang) => cF.hasFoundation
        ? lang.caseFilter.hasFoundation
        : lang.caseFilter.hasNoFoundation,
    paymentPlansStatuses: (cF, lang) => lang.caseFilter.paymentPlanStatuses,
    isNotHavingTheAbovePaymentPlansStatuses: (cF, lang) => lang.caseFilter.paymentPlanIsNotHavingStatusesBadge,
    interactionTypes: (cF, lang) => lang.caseFilter.interactionType,
    interactionStates: (cF, lang) => lang.caseFilter.interactionState,
    interactionDirections: (cF, lang) => lang.caseFilter.interactionDirection,
    noneOfTheAboveInteractions: (cF, lang) => lang.caseFilter.noneOfTheAboveBadge,
    isPaused: (cF, lang) => cF.isPaused
        ? lang.caseFilter.caseIsCurrentlyPaused
        : lang.caseFilter.caseIsCurrentlyNotPaused,
    hasUpdateIds: (cF, lang) => lang.caseFilter.hasFollowingStatusBadge,
    doNotHaveUpdateIds: (cF, lang) => lang.caseFilter.doNotHaveFollowingStatusBadge,
    hasCurrentPauseIds: (cF, lang) => lang.caseFilter.isPausedFollowingStatusBadge,
    doNotHaveCurrentPauseIds: (cF, lang) => lang.caseFilter.isNotPausedFollowingStatusBadge,
    property: (cf, lang, propertyTypes = []) => {
        const property = cf.property;
        if (property == null) {
            return lang.caseFilter.property;
        }
        const propertyType = getPropertyFilterType(propertyTypes, property);
        return `${propertyType?.label ?? lang.caseFilter.property}: ${property.value}`;
    },
    offset: (cF, lang) => `${lang.caseFilter.offset} ${cF.offset}`,
    limit: (cF, lang) => `${lang.caseFilter.limit} ${cF.limit}`,
};
export default filterBadges;
//# sourceMappingURL=filterBadges.js.map